import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type JiraApplicationKey,
	type JiraProjectType,
} from './__generated__/standardAddPaymentModalQuery.graphql';

export type EntryPointParams = {
	chargeElement: string;
	cloudId: string;
	hamsProductKey: string;
	isConfluence: boolean;
	isJira: boolean;
	jiraApplicationKey: JiraApplicationKey;
	projectType: JiraProjectType;
};

export const entryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-standard-add-payment-modal" */ './standard-add-payment-modal'
			),
		{
			moduleId: 'edition-awareness-standard-add-payment-modal',
		},
	),
	getPreloadProps: ({
		cloudId,
		hamsProductKey,
		projectType,
		chargeElement,
		jiraApplicationKey,
		isJira,
		isConfluence,
	}: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			standardAddPaymentModalQuery: {
				parameters,
				variables: {
					cloudId,
					hamsProductKey,
					chargeElement,
					projectType,
					jiraApplicationKey,
					isJira,
					isConfluence,
				},
			},
		},
	}),
});
